function HowItWorks() {
  const steps = [
    {
      number: "1",
      title: "Faites le tri chez vous",
      description:
        "Sélectionnez les vêtements et accessoires que vous souhaitez confier en dépôt. Privilégiez les pièces actuelles, propres et en bon état.",
    },
    {
      number: "2",
      title: "Venez en boutique",
      description:
        "Nous examinons ensemble vos articles directement sur place. L'équipe Les Jolies Choses choisit avec soin les pièces susceptibles de plaire à notre clientèle.",
      note: "(Nous nous réservons le droit de refuser certains articles.)",
    },
    {
      number: "3",
      title: "Vos vêtements trouvent une nouvelle vie",
      description:
        "Les articles retenus sont mis en rayon pour toute une saison, prêts à être découverts et adoptés par de nouvelles clientes.",
    },
    {
      number: "4",
      title: "Suivi et bilan de vos ventes",
      description:
        "À la fin de la période de dépôt, nous retirons les invendus et vous envoyons un mail récapitulatif avec le détail de vos ventes.",
    },
    {
      number: "5",
      title: "Récupérez vos gains",
      description:
        "Passez en boutique récupérer votre chèque ainsi que vos éventuels vêtements restés sans acheteuse.",
    },
  ];

  return (
    <section id="fonctionnement" className="py-16 md:py-24 bg-gradient-to-b from-white to-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 md:mb-16 space-y-3 md:space-y-4">
          <h2 className="text-4xl md:text-5xl font-serif text-text">
            Comment ça marche ?
          </h2>
          <p className="text-primary tracking-widest uppercase font-sans">
            Le fonctionnement du dépôt-vente
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-6 md:space-y-8">
          {steps.map((step, index) => (
            <div key={step.number}>
              <div className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 shadow-lg border border-secondary/30 hover:shadow-xl transition-shadow duration-300">
                <div className="flex gap-4 md:gap-6 items-start">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-primary to-primary/70 flex items-center justify-center text-white shadow-md">
                      <span className="text-xl md:text-2xl font-serif">{step.number}</span>
                    </div>
                  </div>
                  <div className="flex-1 space-y-2 md:space-y-3 min-w-0">
                    <h3 className="text-text font-serif text-lg md:text-xl">{step.title}</h3>
                    <p className="text-text/80 leading-relaxed font-sans">
                      {step.description}
                    </p>
                    {step.note && (
                      <p className="text-text/60 italic font-sans text-sm">
                        {step.note}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Flèche entre les étapes */}
              {index < steps.length - 1 && (
                <div className="flex justify-center my-4 md:my-6">
                  <svg className="w-7 h-7 text-primary transform rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 text-center bg-gradient-to-br from-secondary to-secondary/80 rounded-xl md:rounded-2xl p-6 md:p-8 max-w-3xl mx-auto border border-secondary/30">
          <p className="text-text/80 leading-relaxed font-sans">
            Le dépôt-vente, c'est une solution gagnante pour tous : vous donnez une seconde vie à vos vêtements, 
            nous proposons des pièces de qualité à nos clientes, et ensemble, nous participons à une mode plus responsable.
          </p>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;

